import React from 'react'

import { Switch, useRouteMatch } from 'react-router-dom'

import Box from '@material-ui/core/Box'

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import navigation from './settingsNavigation.constants'
import styles from './settingsStyles'
import { PrivateRoute } from '../../helpers'
import { useTitle } from '../../navigation/helpers/useTitle'

// TODO Navigating to settings should show you as on the dashboard,
// myApps, News, Maps tab and highlight that as the active tab
// This should be done after SideNav rework.
function Settings() {
  useTitle('My Rutgers Settings')
  const classes = styles()

  const { path } = useRouteMatch()
  const { pathname } = useLocation() // Scroll to the top whenever a different Settings page opens.

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <Box className={classes.main} id="main-content">
      <Switch>
        {navigation.map((item) => (
          <PrivateRoute
            key={item.path}
            exact
            path={`${path}${item.path}`}
            component={item.component}
            classes={classes}
          />
        ))}
      </Switch>
    </Box>
  )
}

export default Settings
